import { useQuery } from "@tanstack/react-query";
import { ActiveAntsPurchaseOrderService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";

export const useActiveAntsPurchaseOrder = (
  activeAntsPurchaseOrderId: string,
  activeAntsPurchaseOrderService: ActiveAntsPurchaseOrderService
) => {
  const {
    data: activeAntsPurchaseOrder,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.activeAntsPurchaseOrder(activeAntsPurchaseOrderId),
    queryFn: async () => {
      try {
        return await activeAntsPurchaseOrderService.getActiveAntsPurchaseOrderById(activeAntsPurchaseOrderId);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!activeAntsPurchaseOrderId,
    retry: false
  });

  return { activeAntsPurchaseOrder, fetchError, isLoading, refetch };
};
